import React, { useEffect, useMemo, useState } from "react";
import commonStyles from "../common/CommonStyles.module.css";
import s from "./ContestsPage.module.css";

const ContestsPage = () => {
  const [contests, setContests] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    fetchContests();
  }, []);

  const fetchContests = async () => {
    setIsLoading(true);
    setErrorMessage("");

    try {
      const response = await fetch("/api/contests");
      if (!response.ok) throw new Error("Ошибка при загрузке конкурсов");
      const data = await response.json();
      setContests(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error fetching contests:", error);
      setErrorMessage("Не удалось загрузить конкурсы. Попробуйте позже.");
      setContests([]);
    } finally {
      setIsLoading(false);
    }
  };

  const content = useMemo(() => {
    if (isLoading) {
      return <div className={s.centerMessage}>Загрузка...</div>;
    }

    if (errorMessage) {
      return (
        <div className={s.centerMessage}>
          <div className={s.errorBox}>{errorMessage}</div>
          <button className={s.retryButton} onClick={fetchContests}>
            Повторить
          </button>
        </div>
      );
    }

    if (!contests.length) {
      return <div className={s.centerMessage}>Пока нет активных конкурсов</div>;
    }

    return (
      <div className={s.grid}>
        {contests.map((contest) => (
          <article key={contest.id ?? contest.url} className={s.card}>
            <div className={s.cardHeader}>
              {contest.name && <h3 className={s.contestName}>{contest.name}</h3>}
              {contest.createdAt && (
                <div className={s.meta}>
                  Добавлено: {new Date(contest.createdAt).toLocaleDateString("ru-RU")}
                </div>
              )}
            </div>

            <div className={s.description}>{contest.description}</div>

            <div className={s.footer}>
              <a
                className={s.contestLink}
                href={contest.url}
                target="_blank"
                rel="noopener noreferrer"
                title={contest.url}
              >
                {contest.url}
              </a>
            </div>
          </article>
        ))}
      </div>
    );
  }, [contests, errorMessage, isLoading]);

  return (
    <div className={commonStyles.pageContainer}>
      <div className={commonStyles.contentContainer}>
        <div className={commonStyles.content}>
          <div className={s.header}>
            <h2 className={s.title}>Конкурсы</h2>
            <div className={s.subtitle}>Подборка актуальных конкурсов и ссылок на участие</div>
          </div>
          {content}
        </div>
      </div>
    </div>
  );
};

export default ContestsPage;
